export { getPathname, getPortalId, getRoutename } from './context';
